/**
 * 迅雷9开放API 1.0
 * 
 * `window.definePlugin`可以用来让业务接入方与迅雷9网页进行通讯，同时提供了一些客户端接口可供调用
 * 
 * 代码实例
 * 
 * ```
 * definePlugin(['xl9'], function(xl9){
 *    // 这里启动业务代码
 * })
 * ```
 * 
 * @class XL9
 */
function XL9() {
    var Common = window.common;
    var api = require('./xl_api');
    var _states = {};
    var _events = Common.events;
    var _pubEvents = [
        'XL_WEB_LOGIN', // 登录
        'XL_WEB_LOGOUT',　// 登出
        'XL_TAB_SHOW',　// 底部TAB切换（回调函数的参数是当前TAB的name）
    ];
    var _subEvents = [
        'LOAD', // 模块加载完毕，参数是模块的名称
        'APPSTORE_FOCUS', // 下载中心焦点状态
        'APPSTORE_BLUR'   // 下载中心失焦状态
    ];
    var userInfo = {};

    // 注册相关事件
    registerEvent();
    // 更新用户信息
    getUserInfo();

    /**
     * @class xl9.events
     * @description 事件模块
     */
    this.events = {
        /**
         * 监听事件
         * 
         * 事件名称必须是xl9发布的事件，可以通过`xl9.events.getPub();`获取所有xl9发布的事件
         * @method xl9.events.on
         * @param event {string}　事件名称
         * @param handler {function}　回调函数
         */
        on: function (event, handler) {
            if (_pubEvents.indexOf(event) !== -1) {
                _events.on(event, function () {
                    handler.apply(null, arguments);
                });
            }
        },
        /**
         * 触发事件
         * 事件名字必须是xl9订阅的事件，可以通过`xl9.events.getSub();`获取所有xl9订阅的事件
         * @method xl9.events.trigger
         * @param event {string}　事件名称
         * @param args {array}　参数数组
         */
        trigger: function (event, args) {
            if (_subEvents.indexOf(event) !== -1) {
                _events.trigger(event, args);
            }
        },
        /**
         * 获取所有xl9发布的事件
         * @method xl9.events.getPub
         * @return {array}
         */
        getPub: function () {
            return _pubEvents;
        },
        /**
         * 获取所有xl9订阅的事件
         * @method xl9.events.getSub
         * @return {array}
         */
        getSub: function () {
            return _subEvents;
        }
    };

    /**
     * @class xl9.native
     * @description 客户端接口模块
     */
    this.native = {
        /**
         * @method xl9.native.trackEvent
         * @description 统计上报接口
         * @param key {string} - 统计标识符
         * @param attr1 {string} - 统计attribute1
         * @param attr2 {string} - 统计attribute2
         * @param cost1 {number} - 如有参数extData不可缺省，默认 0
         * @param cost2 {number} - 如有参数extData不可缺省，默认 0
         * @param cost3 {number} - 如有参数extData不可缺省，默认 0
         * @param cost4 {number} - 如有参数extData不可缺省，默认 0
         * @param extData {string}
         */
        trackEvent: function () {
            return api.trackEvent.apply(api, arguments);
        },

        /**
        * @method xl9.native.getThunderVersion
        * @description 获得迅雷客户端版本号
        * @return {string} 客户端版本号，如　9.0.9.276　、7.9.43.5053等, 如果客户端不支持该接口，返回 unknow
        */
        getThunderVersion:  function () {
            return api.getThunderVersion.apply(api, arguments);
        },

        /**
        * @method xl9.native.getPeerID
        * @description 获取peerID
        * @return {string} peerID或空字符串
        */
        getPeerID:  function () {
            return api.getPeerID.apply(api, arguments);
        },
    };

    /**
     * @class xl9.session
     * @description 用户信息模块
     */
    this.session = {
        /**
         * 获取用户信息
         * @method xl9.session.getUserInfo
         * @return {object} 用户信息　{userID: userID, sessionID: sessionID, jumpKey: jumpKey}
         */
        getUserInfo: function () {
            return userInfo;
        },
        /**
         * 拉起登录面板
         * @method xl9.session.login
         */
        login: function () {
            api.showLoginDlg();
        }
    };

    /**
     * @method registerEvent
     * @private
     * 网页触发事件时发出对应事件给接入方
     */
    function registerEvent() {
        var events = _events;
        var XL_WEB_LOGIN = 'XL_WEB_LOGIN';
        var XL_WEB_LOGOUT = 'XL_WEB_LOGOUT';

        // 页面获取完登录态拿到cookie后触发　XL_WEB_LOGIN 事件
        events
            .on('FINISH_JUMP', function () {
                getUserInfo();
                events.trigger(XL_WEB_LOGIN);
            })
            // 页面接收到客户端登出后触发　XL_WEB_LOGOUT 事件
            .on('userLogout', function () {
                getUserInfo();
                events.trigger(XL_WEB_LOGOUT);
            });
    }

    function getUserInfo() {
        var nativeUserID = api.getUserID();
        var jumpKey = api.getJumpKey();
        var webUserID = Common.getCookie('userid');
        var webSessionID = Common.getCookie('sessionid');
        userInfo =  {
            userID: nativeUserID || webUserID,
            sessionID: webSessionID,
            jumpKey: jumpKey
        };
    }
};

module.exports = XL9;


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/xl9_open_api.js
// module id = 8
// module chunks = 1 2 3 5 6 7 8 9 10 11 12